// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fcis-emission-component__modal-intro{margin-top:var(--wb-spacing-s);margin-bottom:var(--wb-spacing-xs)}.emission-button-wrapper{display:flex;align-items:center;padding:20px;gap:16px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
